import { SiteArticleComments } from "../../../../../siteWidgets/SiteArticleComments"
import { getTranslation } from "../../articleComments/translations"
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280"


interface Props {
    articleId: string
    postId: string
    lang?: string
    showFormWhenEmpty?: boolean
    version?: number
    isLTR?: boolean
    ads_mutam_infrastructure_type?: string
    isApp?: boolean
    domain?:string
}
interface State { }

export class ArticleBlogCommentsButton extends React.Component<Props, State> {
    public static siteScriptName = "ArticleBlogCommentsButton"
    public ON_WCM_COMMENTS_RECIVED = "onWcmCommetnsRecived";
    constructor(props) {
        super(props)
        this.state = {
            [`wcmNumOfCommentsInPost_${this.props.postId}`]: '',
        }
    }
    componentDidMount() {
        document.addEventListener(this.ON_WCM_COMMENTS_RECIVED, this.handleWcmCommentsReceived);
    }

    componentWillUnmount() {
        document.removeEventListener(this.ON_WCM_COMMENTS_RECIVED, this.handleWcmCommentsReceived);
    }

    private handleWcmCommentsReceived = (event: CustomEvent) => {
        const postKey = `wcmNumOfCommentsInPost_${this.props.postId}`;
        const commentsCount = event.detail && event.detail[postKey];

        if (commentsCount !== undefined) {
            this.setState({
                [postKey]: commentsCount
            });
        }
    }
    private handleCommentsPopupVisibility = () => {
        // Close any open comment popup first
        const openPopup = document.querySelector('.ArticleCommentsPopup.fadeIn') as HTMLElement;
        const samePopUp = document.querySelector(`.ArticleCommentsPopup.fadeIn.${this.props.postId}`) as HTMLElement;
        if (openPopup) {
            const closePopUpBtn = openPopup.querySelector('.popupCloseIcon') as HTMLElement;
            if (closePopUpBtn && !samePopUp) {
                closePopUpBtn.click();
                // Wait for the popup to close before opening the new one
                setTimeout(() => {
                    this.openCommentsPopup();
                }, 300);
                return;
            }
        }
        
        // No popup is open, open directly
        this.openCommentsPopup();
    }

    private openCommentsPopup = () => {
        if (typeof window !== "undefined" && window[`handleCommentsPopupVisibility_${this.props.postId}`]) {
            window[`handleCommentsPopupVisibility_${this.props.postId}`]();
        }
    }

    public render() {
        const { articleId, postId, isLTR, lang, version, showFormWhenEmpty, ads_mutam_infrastructure_type, isApp, domain } = this.props
        const comments_template_2026 = (typeof window !== "undefined" && window.commentsDisplayType) && window.commentsDisplayType === "comments_template_2026";
        const commentNumber = this.state[`wcmNumOfCommentsInPost_${this.props.postId}`] ? `${getTalkbackNumberView(this.state[`wcmNumOfCommentsInPost_${this.props.postId}`].toString())} תגובות` : getTranslation(lang, "New Comment(premium)");
        const isMobile = typeof window !== "undefined" && window.isMobile1;
        if (!comments_template_2026) return null;
        return (<>
            {isApp ? <a
                href={`/comments_postId=${postId}`}
                className="social-icon tb blog-comments-count-wrapper-pf"
                data-post-id={postId}
                data-spot-id="sp_AJXaDckj"
            >
                <div className="comments-count comments-count-wrapper-pf">{commentNumber}</div>
            </a> : <div
                className="social-icon tb"
                data-post-id={postId}
                onClick={this.handleCommentsPopupVisibility}
            >
                <div className="comments-count comments-count-wrapper-pf">{commentNumber}</div>
            </div>}
            <SiteArticleComments articleId={articleId} domain={domain} blogArticleItem={true} postId={postId} lang={lang} isLtr={isLTR} isGptType={ads_mutam_infrastructure_type} displayType={isMobile ? "firmaMobileWeb" : "firma"} isGrid1280={true} version={version} showFormWhenEmpty={showFormWhenEmpty} />

        </>)
    }

}